import axios from "axios";
import { endSession, isSessionRejected } from "@/shared/session";
import { refreshSession } from "@/shared/token";

// Rotas publicas: 401 nelas e credencial errada, nao sessao vencida.
const PUBLIC_PATHS = ["/sign-in"];

export class BaseAPIClient {
  constructor(baseURL = process.env.VUE_APP_PITCH_API) {
    this.instance = axios.create({
      baseURL,
    });
  }

  // `extra.responseType: "blob"` para baixar arquivo (PDF).
  send(path, method, data, extra = {}) {
    const request = {
      url: path,
      method,
      data,
      responseType: extra.responseType,
      headers: {
        Authorization: "Bearer " + localStorage.getItem("token"),
      },
    };
    if (method === "GET" && data) {
      request.params = data;
    }
    return this.instance.request(request);
  }

  async call(path, method, data, extra = {}) {
    try {
      return await this.send(path, method, data, extra);
    } catch (err) {
      if (PUBLIC_PATHS.includes(path) || !isSessionRejected(err)) throw err;

      // Token de acesso vencido: renova com o refresh e repete a chamada uma
      // vez. Sem renovacao, volta para o login; a tela ainda recebe o erro,
      // mas o admin ja esta saindo dela.
      if (await refreshSession()) {
        try {
          return await this.send(path, method, data, extra);
        } catch (retryErr) {
          if (isSessionRejected(retryErr)) endSession();
          throw retryErr;
        }
      }
      endSession();
      throw err;
    }
  }

  async uploadFiles(formData) {
    return this.call("/upload", "POST", formData, {
      "Content-Type": "multipart/form-data",
    });
  }

  async getFiles(ids) {
    console.log(ids);
    return this.call(`/files?files=${ids}`, "GET");
  }
}
